<nz-spin [nzSpinning]="isLoading">
    <div nz-col nzSpan="24" class="container-fluid">
        <nz-card nzHoverable>
            <div nz-row>
                <div nz-col nzSpan="8" class="text-left">
                    <div style="display: flex; justify-content: space-between;">
                        <span><span nz-icon nzType="user" nzTheme="outline"></span> {{ this.customer.name }}<span style="font-style: italic;" *ngIf="this.parentCustomer" (click)="navigateToCustomer(this.parentCustomer.customerId)" > (Main Debtor: {{this.parentCustomer.name}}) <span nz-icon nzType="sf:openInNew" nzTheme="outline"></span></span><br><br></span>
                                           
                    </div>
                    
                    <span nz-icon nzType="phone" nzTheme="outline"></span> {{ this.customer.cell }}<br>
                    <!-- <i nz-icon nzType="mail" nzTheme="outline" class="back"></i> {{ this.customer.email }} -->
                    
                </div>
                <div nz-col nzSpan="8" class="text-center ">
                    <h6>Vehicle Registrations:</h6>
                    <nz-select [(ngModel)]="this.SelectedVreg" (ngModelChange)="filtertable()" style="width: 80%;">
                        <nz-option nzLabel="All" nzValue="All"> </nz-option>
                        <nz-option *ngFor="let item of vehicles" [nzLabel]="item.vreg + ( item.make ? ' (' + item.make + ( item.model ?  ' ' + item.model + ')' : ')') : '')" [nzValue]="item.vreg"></nz-option>
                    </nz-select>
                </div>
                <div nz-col nzSpan="8" class="text-center" style="text-align: center;">
                    <span class="back">{{ this.localquotes }}</span> Quote<span *ngIf="this.localquotes != 1">s</span> / <span class="back">{{ this.localsales }}</span> Sale<span *ngIf="this.localsales != 1">s</span>
                    <br>
                    <br>
                    <ng-container *ngIf="hasCommunities()">
                    <button nz-button nzType="primary" nzSize="small" nz-tooltip="View Linked Communities for this customer" (click)="this.communityModalOpen = !this.communityModalOpen">
                        <span nz-icon nzType="group" nzTheme="outline"></span>
                        Linked Communities
                    </button>


                    <nz-modal [nzVisible]="communityModalOpen" nzClosable="true" nzTitle="Linked Communities" (nzOnCancel)="communityModalOpen = false;" (nzOnOk)="this.communityModalOpen = !this.communityModalOpen" [nzFooter]="null" nzWidth="400px">
                        <div *nzModalContent>
                            <nz-tree-view [nzTreeControl]="communityTreeControl" [nzDataSource]="communityDataSource">
                                <nz-tree-node *nzTreeNodeDef="let node" nzTreeNodePadding>
                                  <nz-tree-node-toggle nzTreeNodeNoopToggle></nz-tree-node-toggle>
                                  <nz-tree-node-option
                                    [nzDisabled]="node.disabled"
                                    [nzSelected]="selectListSelection.isSelected(node)"
                                    (nzClick)="selectListSelection.toggle(node)"
                                  >
                                  <span nz-icon nzType="check-circle" nzTheme="outline" class="color-success" style="text-align: end;"></span>
                                    {{ node.name }}
                                  </nz-tree-node-option>
                                </nz-tree-node>
                          
                                <nz-tree-node *nzTreeNodeDef="let node; when: hasCommunityChild" nzTreeNodePadding>
                                  <nz-tree-node-toggle>
                                    <span nz-icon nzType="caret-down" nzTreeNodeToggleRotateIcon></span>
                                  </nz-tree-node-toggle>
                                  <nz-tree-node-option
                                    [nzDisabled]="node.disabled"
                                    [nzSelected]="selectListSelection.isSelected(node)"
                                    (nzClick)="selectListSelection.toggle(node)"
                                  >
                                    {{ node.name }}
                                  </nz-tree-node-option>
                                </nz-tree-node>
                              </nz-tree-view>
                        </div>
                        </nz-modal>


                </ng-container>
                </div>
            </div>
            <br>
            <div nz-row class="text-center"   style="height:inherit">
                <div nz-col nzSpan="8" class="text-left">
                    <ng-container *ngIf="hasSubcustomers()" >
                        <button nz-button nzType="primary" nzSize="large" nz-tooltip="View Linked Customers" (click)="this.subCustomerModalOpen = !this.subCustomerModalOpen" style="margin-right: 10px;">
                            <span nz-icon nzType="team" nzTheme="outline"></span>
                         Linked Customers
                        </button>
                      <nz-modal [nzVisible]="subCustomerModalOpen" nzClosable="true" nzTitle="Linked Customers" (nzOnCancel)="subCustomerModalOpen = false;" (nzOnOk)="this.subCustomerModalOpen = !this.subCustomerModalOpen" [nzFooter]="null" nzWidth="60%">
                        <div *nzModalContent>
                            <nz-tree-view [nzTreeControl]="treeControl" [nzDataSource]="dataSource">
                                <nz-tree-node *nzTreeNodeDef="let node" nzTreeNodePadding>
                                    <nz-tree-node-toggle nzTreeNodeNoopToggle></nz-tree-node-toggle>
                                    <nz-tree-node-option
                                        [nzDisabled]="node.disabled"
                                        [nzSelected]="selectListSelection.isSelected(node)"
                                        (nzClick)="selectListSelection.toggle(node)"
                                    >
                                        <span >{{ node.name }}</span>
                                        <span *ngIf="node.email" style="font-size: 12px; color: gray; margin-left: 10px;" >{{ node.email }}</span>
                                        <span *ngIf="node.cell" style="font-size: 12px; color: gray; margin-left: 10px;">{{ node.cell }}</span>
                                       
                                    </nz-tree-node-option>
                                    <span (click)="navigateToCustomer(node.customerId); subCustomerModalOpen=false" nz-icon nzType="sf:openInNew" nzTheme="outline"></span>
                                    </nz-tree-node>
                            
                                    <nz-tree-node *nzTreeNodeDef="let node; when: hasChild" nzTreeNodePadding>
                                    <nz-tree-node-toggle>
                                        <span nz-icon nzType="caret-down" nzTreeNodeToggleRotateIcon></span>
                                    </nz-tree-node-toggle>
                                    <nz-tree-node-option
                                        [nzDisabled]="node.disabled"
                                        [nzSelected]="selectListSelection.isSelected(node)"
                                        (nzClick)="selectListSelection.toggle(node)"
                                        >
                                        <span>{{ node.name }}</span>
                                        <span *ngIf="node.email" style="font-size: 12px; color: gray; margin-left: 10px;">{{ node.email }}</span>
                                        <span *ngIf="node.cell" style="font-size: 12px; color: gray; margin-left: 10px;">{{ node.cell }}</span>
                                    </nz-tree-node-option>
                                    <span (click)="navigateToCustomer(node.customerId); subCustomerModalOpen=false" nz-icon nzType="sf:openInNew" nzTheme="outline"></span>
                                </nz-tree-node>
                            </nz-tree-view>
                        </div>
                        </nz-modal>
                    </ng-container>
                    <button nz-button nzType="primary" nzSize="large" (click)="openCustomer()">
                            <span nz-icon nzType="edit" nzTheme="outline"></span>
                            Edit Customer 
                        </button>
                </div>
                <div nz-col nzSpan="8">
                    <app-searchbar></app-searchbar>
                    <br>
                </div>
                <div nz-col nzSpan="8">
                    <h6> Total Sales</h6>
                    <span class="text-style" style="font-weight:600;"> R {{ total() | number }} </span>
                </div>
            </div>
            <nz-divider></nz-divider>
            <div nz-row nzJustify="center">
                <div nz-col nzSpan="24">
                    <nz-spin [nzSpinning]="isLoading">
                        <nz-table #lines [nzData]="ShowLines" [nzFrontPagination]="true" [nzPageSize]="25">
                            <thead>
                                <tr>
                                    <th [nzFilters]="leadFilterValues" [nzFilterFn]="leadFilterFn">Lead Type</th>
                                    <th>Date</th>
                                    <th>Tyre Size</th>
                                    <th>Tyre Brands</th>
                                    <th>Channel</th>
                                    <th>Total <small class="text-style">(Vat Excl)</small></th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody class="tbody">
                                <tr *ngFor="let item of lines.data">
                                    <td>
                                        <span *ngIf="item.salequote == 'quote'"><span nz-icon nzType="file-text" nzTheme="outline"></span> Quote</span>
                                        <span *ngIf="item.salequote == 'sale'"><span class="text-success" nz-icon nzType="credit-card" nzTheme="outline"></span> Sale</span>
                                    </td>
                                    <td>
                                        {{ item.dtcreated }}
                                    </td>
                                    <td>
                                        <div *ngFor="let item of item.LineItems; let i=index">
                                            <span *ngIf="i<1">
                                                <span *ngIf="item.stocktype == 'TYRE'">
                                                    {{ item.Size }}
                                                </span>
                                            <span *ngIf="item.stocktype == 'NONE STOCK'">
                                                    Service
                                                </span>
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <span *ngFor="let line of item.LineItems">
                                            <img *ngIf="line.stocktype == 'TYRE'" class="brandImage-customer" style='margin-left: 1%;border-radius: 10px;' height='25' width='50' src='assets/Images/brands/{{line.Brand}}'>   
                                    </span>
                                        <span>
                                        <img *ngIf="hasService(item.LineItems)" class="brandImage-customer" style='margin-left: 1%;border-radius: 10px;' height='25' width='50' src='assets/Images/brands/service.jpg'> 
                                    </span>
                                    </td>
                                    <td>
                                        <span *ngIf="item.Ref.startsWith('S') || item.Ref.startsWith('N') ">Created  with <img src="../../assets/Images/s-logo-white.png" height='25' width='25'></span>
                                        <span *ngIf="item.Ref.startsWith('E')">Created Externally 
                                            <i nz-icon nzType="laptop" nzTheme="outline" class=" text"></i>
                                        
                                        </span>
                                    </td>
                                    <td>
                                        <span *ngIf="item.sellerId != authService.user.client_id">
                                            <button nz-button nzType="primary">External</button> 
                                        </span>
                                        <span *ngIf="item.sellerId == authService.user.client_id">
                                                <span class="text-info-style">R </span> {{ item.Price | number }}
                                        </span>
                                    </td>
                                    <td>
                                        <span *ngIf="item.sellerId != authService.user.client_id">
                                            <button nz-button nzType="primary">External</button> 
                                        </span>
                                        <span *ngIf="item.sellerId == authService.user.client_id">
                                            <span *ngIf="item.salequote == 'quote'">
                                                <span *ngIf="item.stateId == 1 || item.stateId == 2">
                                                    Work In Progress
                                                    <span nz-icon nzType="hourglass" nzTheme="outline"></span>
                                        </span>
                                        <span *ngIf="item.stateId == 3">
                                                    <span *ngIf="item.stateType == 1">
                                                        {{ item.status }} 
                                                        <i nz-icon nzType="check" nzTheme="outline" class="text"></i>
                                                    </span>
                                        <span *ngIf="item.stateType == 0">
                                                        {{ item.status }}
                                                        <i nz-icon nzType="check" nzTheme="outline"  class="text-danger-style"></i>
                                                    </span>
                                        </span>
                                        </span>
                                        <span *ngIf="item.salequote == 'sale'">
                                                <span *ngIf="item.stategroup == 1">        
                                                    {{ item.status }}
                                                    <i nz-icon [nzType]="'loading'"  class="text-warning-style"></i>
                                                </span>
                                        <span *ngIf="item.stategroup == 2">
                                                    {{ item.status }}
                                                    <i nz-icon nzType="check" nzTheme="outline" class="text"></i>
                                                </span>
                                        <span *ngIf="item.stategroup == 3">
                                                    {{ item.status }}
                                                    <i nz-icon nzType="close" nzTheme="outline" class="text-danger-style"></i>
                                                </span>
                                        <span *ngIf="item.stategroup == 4">
                                                    <i nz-icon nzType="check" nzTheme="outline" class=" text"></i>
                                                    {{ item.status }}
                                                </span>
                                        </span>
                                        </span>
                                    </td>
                                    <td>
                                        <span *ngIf="item.sellerId != authService.user.client_id">                         
                                        </span>
                                        <span *ngIf="item.sellerId == authService.user.client_id">
                                            <span *ngIf="item.salequote == 'quote'">
                                                <button nz-button nzType="primary" (click)="route(item.Id)"><span nz-icon nzType="export" nzTheme="outline"></span></button>
                                        </span>
                                        <span *ngIf="item.salequote == 'sale'">
                                                <button nz-button nzType="primary" (click)="routesale(item.Id)"><span nz-icon nzType="export" nzTheme="outline"></span></button>
                                        </span>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </nz-table>
                    </nz-spin>
                </div>
            </div>
        </nz-card>
    </div>
</nz-spin>